export default __webpack_public_path__ + "assets/upload.6cc1e93c.svg";